import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-generic-error",
    templateUrl: "./generic-notification.component.html",
    styleUrls: ["./generic-notification.component.scss"]
})
export class GenericNotificationComponent {
    html: string;

    constructor(@Inject(MAT_DIALOG_DATA) data: string) {
        this.html = data;
    }
}

